<template>
<div class="mapa-financeiro">
  <nav-menu></nav-menu>
  <div class="w3-row w3-container w3-col w3-margin-top " style="padding:0">
  
    <header class="w3-padding-large">
      <h5 class="w3-left w3-col s12" v-cloak>
        <div class="w3-col s12">
          <b>
            <i class="fa fa-map fa-fw"/> 
            Mapa Financeiro
          </b>
        </div>

        <div v-if="conf_local.definido">

          <button 
            :disabled="processando" 
            class="w3-button w3-theme w3-right"
            @click="abrirConfiguracoesFinanceiro()">
            <i class="fa fa-cog"/>
          </button>

          <span 
            class="w3-right">
            &nbsp;
          </span>

          <button 
            :disabled="processando" 
            class="w3-button w3-theme w3-right" 
            @click="abrirColetarPeriodo()">
            <i class="fa fa-calendar"/>
            <span>{{fData(conf_local.data_inicial)}} - {{fData(conf_local.data_final)}}</span>
          </button>

        </div>

      </h5>
    </header>

    <div 
      style="padding: 0 20%"
      class="w3-col s12 m12 l12 w3-margin-bottom" 
      v-show="!conf_local.definido">
      <div class="w3-panel w3-theme w3-card-2">
        <p>
          <i class="fa fa-exclamation-triangle"/> 
          Para obter os dados do painel financeiro, é necessário realizar a configuração dos paramêtros. 
          <strong style="text-decoration: underline;" @click="abrirConfiguracoesFinanceiro()">CLIQUE AQUI</strong> para configurá-los
        </p>
      </div>
    </div>

    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando && conf_local.definido" style="padding: 0 20%">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div class="w3-block w3-container w3-row-padding w3-col w3-margin-top" v-if="!processando && conf_local.definido">

      <div class="w3-row w3-col s12 m12 l4 w3-half w3-margin-bottom flexbox-pai">
        <div class="w3-col s12 item">
          <div 
            style="background-color: #f5f5f5"
            class=" w3-padding"
            v-show="existeCardsSaldos">

            <h5 style="margin:0"><b> Saldos de caixas e bancos</b></h5>
          </div>

          <div
            class="bloco w3-col s12"
            v-show="conf_local.visibilidade.contas_caixa">

            <div class="w3-col s12  l5 w3-large">Conta caixa</div>
            <div
              class="w3-col s12 l7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.conta_caixa)">
              <span>R$ {{saldos_mapa_financeiro.conta_caixa}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12"
            v-show="conf_local.visibilidade.contas_bancarias">

            <div class="w3-col s12  l5 w3-large">Contas bancárias</div>
            <div
              class="w3-col s12 l7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.conta_bancaria)">
              <span>R$ {{saldos_mapa_financeiro.conta_bancaria}}</span>
            </div>
          </div>

        </div>
      </div>

       <div class="w3-row  w3-col s12 m12 l4 w3-half w3-margin-bottom flexbox-pai">
        <div class="w3-col s12 item">
          <div
            style="background-color: #f5f5f5"
            class=" w3-padding"
            v-show="existeCardsPrevisoesInicioRelatorio">

            <h5 style="margin: 0">
              <b> Previsões até o início do relatório</b>
            </h5>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.pagar_previsoes">
            
            <div class="w3-col s12 l5  w3-large">A pagar</div>
            <div
              class="w3-col s12 l7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.previsao_pagar_aberta)">
              <span>R$ {{saldos_mapa_financeiro.previsao_pagar_aberta}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.receber_previsoes">
            <div class="w3-col s12 l5 w3-large">A receber</div>
            <div
              class="w3-col s12 l7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.previsao_receber_aberta)">
              <span>R$ {{saldos_mapa_financeiro.previsao_receber_aberta}}</span>
            </div>
          </div>

        </div>
      </div>

      <div class="w3-row w3-col s12 m12 l4 w3-margin-bottom flexbox-pai">
        <div class="w3-col s12 item">
          <div
            style="background-color: #f5f5f5"
            class="w3-padding"
            v-show="existePrevisoesVencidas">

            <h5 style="margin:0"><b> Previsões vencidas</b></h5>
          </div>

          <div
            class="bloco w3-col s12"
            v-if="conf_local.visibilidade.previsoes_pagar_vencidas">
            
            <div class="w3-col s12 l5  w3-large">Previsões a pagar vencidas</div>
            <div
              class="w3-col s12 l7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.previsoes_pagar_vencidas)">
              <span>R$ {{saldos_mapa_financeiro.previsoes_pagar_vencidas}}</span>
            </div>
          </div>          
        </div>
      </div>

      <div class="w3-row w3-col s12 m12 l6 w3-half w3-margin-bottom flexbox-pai2">
        <div class="w3-col s12 item">
          <div
            style="background-color: #f5f5f5"
            class="w3-padding"
            v-show="existeCardsRealizadoInicioRelatorio">

            <h5 style="margin: 0">
              <b>Realizado até o início do relatório</b>
            </h5>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.receber_realizado">

            <div class="w3-col s12 l6 w3-large">A receber</div>
            <div
              class="w3-col s12 l6"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_abertos )">
              <span>R$ {{saldos_mapa_financeiro.receber_abertos}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.cheques_pagar">

            <div class="w3-col s12 l6 w3-large">Cheques a pagar (vencidos)</div>
            <div
              class="w3-col s12 l6"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.cheque_pagar_vencidos)">
              <span>R$ {{saldos_mapa_financeiro.cheque_pagar_vencidos}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.pagar_duplicata_cheque_abertos">

            <div class="w3-col s12 l6 w3-large">A pagar (duplicata e cheque abertos)</div>
            <div
              class="w3-col s12 l6"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.pagar_duplicata_cheque_abertos)">
              <span>R$ {{saldos_mapa_financeiro.pagar_duplicata_cheque_abertos}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 m12"
            v-show="conf_local.visibilidade.dbc_pagar_vencidos">

            <div class="w3-col s12 l6 w3-large">Duplicata/boleto/crédito a pagar(vencidos)</div>
            <div
              class="w3-col s12 l6"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.duplicata_pagar_vencidos)">
              <span>R$ {{saldos_mapa_financeiro.duplicata_pagar_vencidos}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="w3-row w3-col  s12 m12 l6 w3-half w3-right w3-margin-bottom flexbox-pai2">
        <div class="w3-col s12 item">
          <div
            style="background-color: #f5f5f5"
            class="w3-padding"
            v-show="existeCardsTitulosReceber">

            <h5 style="margin:0">
              <b>Títulos a receber vencidos a N dias (acumulado) - somente informativo</b>
            </h5>
          </div>

          <div
            class="bloco w3-col s12 l6 l12"
            v-show="conf_local.visibilidade.tres_dias">

            <div class="w3-col s3 m5 w3-large">3 dias</div>
            <div
              class="w3-col s9 m7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_tres)">
              <span>R$ {{saldos_mapa_financeiro.receber_tres}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 l6 l12"
            v-show="conf_local.visibilidade.quinze_dias">

            <div class="w3-col s3 m5 w3-large">15 dias</div>
            <div
              class="w3-col s9 m7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_quinze)">
              <span>R$ {{saldos_mapa_financeiro.receber_quinze}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 l6 l12"
            v-show="conf_local.visibilidade.trinta_dias">

            <div class="w3-col s3 m5 w3-large">30 dias</div>
            <div
              class="w3-col s9 m7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_trinta)">
              <span>R$ {{saldos_mapa_financeiro.receber_trinta}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 l6 l12"
            v-show="conf_local.visibilidade.sessenta_dias">
            
            <div class="w3-col s3 m5 w3-large">60 dias</div>
            <div
              class="w3-col s9 m7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_sessenta)">
              <span>R$ {{saldos_mapa_financeiro.receber_sessenta}}</span>
            </div>
          </div>

          <div
            class="bloco w3-col s12 l6 l12"
            v-show="conf_local.visibilidade.noventa_dias">

            <div class="w3-col s3 m5 w3-large">90 dias</div>
            <div
              class="w3-col s9 m7"
              style="text-align: right"
              :class="buscarClasseDados(saldos_mapa_financeiro.receber_noventa)">
              <span>R$ {{saldos_mapa_financeiro.receber_noventa}}</span>
            </div>
          </div>

        </div>
      </div>

      <div class="w3-row w3-margin-top  text-center w3-col s12 w3-margin-bottom w3-padding-small" style="padding:0">
        <a @click.stop.prevent="mudarAbaMapaFinanceiro('sintetico', 1);">
          <div :class="buscarClassesPagina(1)">
            <span>Sintético</span>
          </div>
        </a>

        <a @click.stop.prevent="mudarAbaMapaFinanceiro('analitico-modelo-dois', 2);">
          <div :class="buscarClassesPagina(2)">
            <span>Analítico Modelo Dois</span>
          </div>
        </a>
      </div>

      <div id="sintetico" class="mapa-financeiro-modelo w3-animate-left w3-col s12"  style="padding:0">
        
        <div class="w3-container table-mapa-financeiro w3-padding-small">
          <mapa-financeiro-sintetico :mapa_financeiro_dados="mapa_financeiro_dados"/>
        </div>

        <totalizadores-mapa-sintetico :dados="dados_mapa_financeiro"/>
      </div>

      <div id="analitico-modelo-dois" class="mapa-financeiro-modelo w3-animate-left " style="display:none">
        <mapa-financeiro-card-modelo-dois 
          :dados="analitico_modelo_dois" 
          :dadosMapaFinanceiro="dados_mapa_financeiro"
        />
      </div>
    
      <button 
        id="floating-button" 
        title="Recarregar dados" 
        v-if="exibindoConfiguracoesFinanceiro()"
        style="border-radius: 50% !important; z-index: 9999"
        class="w3-button w3-theme w3-circle w3-display-bottomright" 
        v-on:click="recarregarInformacoes()">
        <i class="fa fa-sync-alt"/>
      </button>
    </div>
  </div>

  <configuracoes-financeiro
    ref="configuracoesFinanceiro"
    @confirmar="confirmarConfiguracoesFinanceiro()"
  />

  <coletar-periodo
    ref="coletarPeriodo"
    dataFinalSomenteLeitura="S"
    obrigarDataInicialMaiorDataAtual="S"
    :maximoDias="60"
    :quantidadeDiasDataFinal="valor(this.conf_local.quantidade_dias)"
    :dataInicial="fData(this.conf_local.data_inicial)"
    :dataFinal="fData(this.conf_local.data_final)"
    @confirmar="confirmarColetarPeriodo"
  />

</div>
</template>
<script>
  import moment from 'moment'
  import NavMenu from '@/components/Menu'
  import ColetarPeriodo from '@/components/ColetarPeriodo'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import MapaFinanceiroCard from '@/components/MapaFinanceiroCard'
  import RMapaFinanceiro from '@/components/Rest/RMapaFinanceiro.js'
  import ConfiguracoesFinanceiro from '@/components/ConfiguracoesFinanceiro'
  import MapaFinanceiroSintetico from '@/components/MapaFinanceiroSintetico.vue'
  import TotalizadoresMapaSintetico from '@/components/TotalizadoresMapaSintetico'
  import TotalizadoresMapaFinanceiro from '@/components/TotalizadoresMapaFinanceiro'
  import MapaFinanceiroCardModeloDois from '@/components/MapaFinanceiroCardModeloDois'

  export default {
    name: 'MapaFinanceiro',
    components: {
      MapaFinanceiroCard,
      MapaFinanceiroCardModeloDois,
      TotalizadoresMapaFinanceiro,
      MapaFinanceiroSintetico,
      TotalizadoresMapaSintetico,
      NavMenu,
      moment,
      ConfiguracoesFinanceiro,
      ColetarPeriodo
    },
    data() {
      return {
        tabAtiva: 1,
        processando: false,
        
        dados_mapa_financeiro: [],
        mapa_financeiro_dados: [],
        analitico_modelo_dois: [],
        saldos_mapa_financeiro: {}, 
        conf_local: {},
      }
    },
    
    methods: {
      abrirConfiguracoesFinanceiro() {
        this.$refs.configuracoesFinanceiro.abrir();
      },

      exibindoConfiguracoesFinanceiro(){
        return !this.$refs.configuracoesFinanceiro.visivel;
      },

      async confirmarConfiguracoesFinanceiro(){
        await this.buscarConfiguracoesLocais();
        await this.buscarMapaFinanceiro();
      },

      abrirColetarPeriodo() {
        this.$refs.coletarPeriodo.abrir();
      },

      confirmarColetarPeriodo(periodo){
        this.conf_local.data_inicial = periodo.data_inicial;
        this.conf_local.data_final = periodo.data_final;
        this.buscarMapaFinanceiro();
      },

      existeConfiguracaoLocal(){
        return (Object.keys(this.conf_local.visibilidade).length > 0);
      },

      async buscarConfiguracoesLocais() {
        try {
          let cConfiguracoes_Mapa_Financeiro = 'configuracoes-mapa-financeiro';
          
          if (!localStorage.getItem(cConfiguracoes_Mapa_Financeiro)) {
            return;
          }

          this.conf_local = await JSON.parse(localStorage.getItem(cConfiguracoes_Mapa_Financeiro));

          /* Conferinco as configurações */
          if (this.conf_local.quantidade_dias <= 0) {
            return;
          }

          /* Aplicando configurações na tela */
          this.conf_local.data_inicial = new Date();
          this.conf_local.data_final = new Date();

          this.conf_local.data_final.setDate(this.conf_local.data_inicial.getDate() + Biblioteca.valor(this.conf_local.quantidade_dias));
          this.conf_local.definido = true;
        } catch (error) {
          this.conf_local = {};
        }
      },

      fData(data) {
        return Biblioteca.fData(data);
      },

      valor(valor){
        return Biblioteca.valor(valor);
      },

      buscarClassesPagina(numero_pagina) {
        if (this.tabAtiva == numero_pagina) {
          return 'w3-half tablink tab-active-inverse active w3-text-white w3-padding w3-border';
        }
        else {
          return 'w3-half	tablink w3-padding tab-active-inverse w3-border';
        }
      },
      
      recarregarInformacoes: function() {
        this.buscarMapaFinanceiro();
        setTimeout(this.atualizarMesmoValorCardSelecionado, .5);
      },

      processarNovasConfiguracoesFinanceiro: function() {
        if(this.conf_local.data_inicial == "" || this.conf_local.data_final == "") {
          Biblioteca.exclamar('Nenhuma data pode estar em branco.')
        }
        else if(this.conf_local.data_inicial > this.conf_local.data_final) {
          Biblioteca.exclamar('A data inicial não pode ser maior que a data final!')
        }
        else {
          this.mostrarmodalConfiguracoes = false
          window.scrollTo(0, 0);
          this.conf_local.quantidade_dias = this.buscarDiferencaEntreDias();
          this.buscarMapaFinanceiro();
        }
      },

      buscarClasseTab(tab) {
        if(this.tab_selecionada == tab) {
          return 'w3-half tablink w3-theme w3-text-white w3-padding'
        } else {
          return 'w3-half	tablink w3-padding w3-hover-light-grey'
        }
      },

      mudarAbaMapaFinanceiro: function(modelo, tab) {
        this.tabAtiva = tab

        let x = document.getElementsByClassName("mapa-financeiro-modelo");
        for (let i = 0; i < x.length; i++) {
          x[i].style.display = "none";
        }

        document.getElementById(modelo).style.display = "block";
        this.$forceUpdate();
      },

      strPadraoToNumber: function(str){
        let aux = str;
        aux = aux.split(".").join("");
        aux = aux.replace(',','.');
        return aux;
      },

      buscarDatasEntreDatas() {
        let vetor_datas = [];

        let inicio = Biblioteca.strToDate(this.conf_local.data_inicial);
        let fim = new Date(moment(inicio, 'YYYY-MM-DD').add(Biblioteca.valor(this.conf_local.quantidade_dias) + 1, 'days').format('YYYY-MM-DD'));

        while(inicio < fim){
          vetor_datas.push(moment(inicio).format('DD/MM/YYYY'));
          let novaData = inicio.setDate(inicio.getDate() + 1);
          inicio = new Date(novaData);
        }

        return vetor_datas;
      },

      buscarClasseDados: function(dado) {
        if(dado) {
          if(dado.length > 12) {
            return 'card-dashboard-dado texto-reduzido'
          } else {
            return 'card-dashboard-dado'
          }
        }
      },

      buscarQuantidadeInformacoesFinanceiro: function(nome_saldo) {
        return '';
      },
      
      async buscarMapaFinanceiro() {
        if (!this.conf_local.definido) {
          return;
        }

        this.processando = true;

        try {
          let parametros = JSON.parse(JSON.stringify(this.conf_local));
          if (parametros.formas_pagamento) {
            parametros.formas_pagamento.forma_boleto = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_boleto
            );

            parametros.formas_pagamento.forma_credito = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_credito
            );

            parametros.formas_pagamento.forma_cheque_prazo = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_cheque_prazo
            );

            parametros.formas_pagamento.forma_cheque_vista = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_cheque_vista
            );

            parametros.formas_pagamento.forma_duplicata = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_duplicata
            );

            parametros.formas_pagamento.forma_previsao = Biblioteca.booleanToChar(
              parametros.formas_pagamento.forma_previsao
            );
          }

          if (parametros.omissoes) {
            parametros.omissoes.caixas = Biblioteca.booleanToChar(
              parametros.omissoes.caixas
            );

            parametros.omissoes.empresas = Biblioteca.booleanToChar(
              parametros.omissoes.empresas
            );

            parametros.omissoes.portadores_a_receber = Biblioteca.booleanToChar(
              parametros.omissoes.portadores_a_receber
            );

            parametros.omissoes.portadores_a_pagar = Biblioteca.booleanToChar(
              parametros.omissoes.portadores_a_pagar
            );

            parametros.omissoes.alineas = Biblioteca.booleanToChar(
              parametros.omissoes.alineas
            );
          }

          if (parametros.checkbox) {
            parametros.checkbox.contas_caixa = Biblioteca.booleanToChar(
              parametros.checkbox.contas_caixa
            );

            parametros.checkbox.contas_bancarias = Biblioteca.booleanToChar(
              parametros.checkbox.contas_bancarias
            );
            
            parametros.checkbox.receber_realizado = Biblioteca.booleanToChar(
              parametros.checkbox.receber_realizado
            );
            
            parametros.checkbox.cheques_pagar = Biblioteca.booleanToChar(
              parametros.checkbox.cheques_pagar
            );
            
            parametros.checkbox.pagar_duplicata_cheques_abertos = Biblioteca.booleanToChar(
              parametros.checkbox.pagar_duplicata_cheques_abertos
            );
            
            parametros.checkbox.dbc_pagar_vencidos = Biblioteca.booleanToChar(
              parametros.checkbox.dbc_pagar_vencidos
            );
            
            parametros.checkbox.pagar_previsoes = Biblioteca.booleanToChar(
              parametros.checkbox.pagar_previsoes
            );
            
            parametros.checkbox.receber_previsoes = Biblioteca.booleanToChar(
              parametros.checkbox.receber_previsoes
            );
            
            parametros.checkbox.tres_dias = Biblioteca.booleanToChar(
              parametros.checkbox.tres_dias
            );
            
            parametros.checkbox.quinze_dias = Biblioteca.booleanToChar(
              parametros.checkbox.quinze_dias
            );
            
            parametros.checkbox.trinta_dias = Biblioteca.booleanToChar(
              parametros.checkbox.trinta_dias
            );
            
            parametros.checkbox.sessenta_dias = Biblioteca.booleanToChar(
              parametros.checkbox.sessenta_dias
            );
            
            parametros.checkbox.noventa_dias = Biblioteca.booleanToChar(
              parametros.checkbox.noventa_dias
            );
            
            parametros.checkbox.previsoes_pagar_vencidas = Biblioteca.booleanToChar(
              parametros.checkbox.previsoes_pagar_vencidas
            );
          }

          parametros.data_inicial = Biblioteca.fData(parametros.data_inicial);
          parametros.data_final = Biblioteca.fData(parametros.data_final);

          let retorno = await RMapaFinanceiro.buscarMapaFinanceiro(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          
          /* ------------ INFORMAÇÕES ESTATÍSTICAS ------------ */
          let informacoes_estaticas = retorno.dados.informacoes_estaticas;

          this.saldos_mapa_financeiro = {
            conta_caixa: informacoes_estaticas.saldo_conta_caixa,
            conta_bancaria: informacoes_estaticas.saldo_conta_bancaria,
            receber_abertos: informacoes_estaticas.saldo_receber_abertos,
            cheque_pagar_vencidos: informacoes_estaticas.saldo_cheque_pagar_vencidos,
            pagar_duplicata_cheque_abertos: informacoes_estaticas.saldo_pagar_duplicata_cheque_abertos,
            duplicata_pagar_vencidos: informacoes_estaticas.saldo_duplicata_pagar_vencidos,
            previsao_pagar_aberta: informacoes_estaticas.saldo_previsao_pagar_aberta,
            previsao_receber_aberta: informacoes_estaticas.saldo_previsoes_receber,
            previsoes_pagar_vencidas: informacoes_estaticas.saldo_previsoes_pagar_vencidas,
            receber_tres: informacoes_estaticas.saldo_receber_tres,
            receber_quinze: informacoes_estaticas.saldo_receber_quinze,
            receber_trinta: informacoes_estaticas.saldo_receber_trinta,
            receber_sessenta: informacoes_estaticas.saldo_receber_sessenta,
            receber_noventa: informacoes_estaticas.saldo_receber_noventa
          };

          /* ------------ INFORMAÇÕES ANALITICAS MODELO 1 ------------ */
          let informacoes_analitico_modelo_1 = retorno.dados.informacoes_analitico_modelo_1;
          let portador_conta_receber = informacoes_analitico_modelo_1.portador_conta_receber;
          let valores_conta_receber = informacoes_analitico_modelo_1.valores_conta_receber;
          let plano_financeiro_conta_pagar = informacoes_analitico_modelo_1.plano_financeiro_conta_pagar;
          let valores_conta_pagar = informacoes_analitico_modelo_1.valores_conta_pagar;
          let previsoes_venda = informacoes_analitico_modelo_1.valores_previsao_venda;
          let plano_financeiro_previsao_pagar = informacoes_analitico_modelo_1.plano_financeiro_previsao_pagar;
          let valores_previsao_pagar = informacoes_analitico_modelo_1.valores_previsao_pagar;

          let vencimentos = this.buscarDatasEntreDatas();

          this.mapa_financeiro_dados = [];

          let saldo_inicial = Biblioteca.valor(informacoes_estaticas.saldo_inicial);

          let dados_mapa_financeiro = {
            total_saldos: null,
            total_contas_receber: null,
            total_previsoes_venda: null,
            total_receber: null,
            total_contas_pagar: null,
            total_previsoes_pagar: null
          };

          for (let i in vencimentos) {
            let array_por_vencimentos_contas_receber =  valores_conta_receber.filter(
              function(valor) {
                return valor.vencimento == vencimentos[i];
              }
            );

            let array_por_vencimentos_contas_pagar =  valores_conta_pagar.filter(
              function(valor) {
                return valor.vencimento == vencimentos[i];
              }
            );

            let array_por_vencimentos_previsao_pagar = valores_previsao_pagar.filter(
              function(valor) {
                return valor.vencimento == vencimentos[i]
              }
            );

            this.mapa_financeiro_dados.push(
              {
                contas_receber: [],
                contas_pagar: [],
                previsoes_pagar: [],
                saldo_inicial: 0,
                saldo_final: 0,
                total_pagar: 0,
                total_a_receber: 0,
                total_realizado: 0,
                total_previsto: 0,
                total_realizado_previsto: 0,
                data_vencimento: '',
                previsoes_venda: '',
                soma_contas_receber: '',
                soma_contas_pagar: '',
                soma_previsoes_pagar: ''
              }
            );

            this.mapa_financeiro_dados[i].contas_receber = Object.assign([], array_por_vencimentos_contas_receber);
            this.mapa_financeiro_dados[i].contas_pagar = Object.assign([], array_por_vencimentos_contas_pagar);
            this.mapa_financeiro_dados[i].previsoes_pagar = Object.assign([], array_por_vencimentos_previsao_pagar);
            this.mapa_financeiro_dados[i].data_vencimento = vencimentos[i];
            this.mapa_financeiro_dados[i].soma_contas_receber = 0;
            this.mapa_financeiro_dados[i].soma_contas_pagar = 0;
            this.mapa_financeiro_dados[i].soma_previsoes_pagar = 0;
            this.mapa_financeiro_dados[i].saldo_inicial = saldo_inicial;
            this.mapa_financeiro_dados[i].saldo_final = 0;

            for (let x = 0; x < previsoes_venda.length; x++) {
              if (previsoes_venda[x].vencimento == this.mapa_financeiro_dados[i].data_vencimento) {
                this.mapa_financeiro_dados[i].previsoes_venda = previsoes_venda[x].total;
              }
            }

            if (this.mapa_financeiro_dados[i].previsoes_venda == '') {
              this.mapa_financeiro_dados[i].previsoes_venda = '0,00';
            }

            this.mapa_financeiro_dados[i].soma_contas_receber = (
              this.mapa_financeiro_dados[i].contas_receber.reduce(
                (total_soma_contas_receber, elem) => 
                total_soma_contas_receber + 
                Biblioteca.valor(elem.total), 
                0
              )
            );

            for (let j = 0; j < this.mapa_financeiro_dados[i].contas_receber.length; j++) {
              for (let z = 0; z < portador_conta_receber.length; z++) {
                if (
                  this.mapa_financeiro_dados[i].contas_receber[j].portador_id == 
                  portador_conta_receber[z].portador_id
                ) {
                  this.mapa_financeiro_dados[i].contas_receber[j].portador_nome = portador_conta_receber[z].nome;
                  break;
                }
              }

              delete this.mapa_financeiro_dados[i].contas_receber[j].portador_id;
              delete this.mapa_financeiro_dados[i].contas_receber[j].vencimento;
            }

            this.mapa_financeiro_dados[i].soma_contas_pagar = (
              this.mapa_financeiro_dados[i].contas_pagar.reduce(
                (total_soma_contas_pagar, elem) => 
                total_soma_contas_pagar + 
                Biblioteca.valor(elem.total), 
                0 
              )
            );

            for (let j = 0; j < this.mapa_financeiro_dados[i].contas_pagar.length; j++) {
              for (let y = 0; y < plano_financeiro_conta_pagar.length; y++) {
                if (
                  this.mapa_financeiro_dados[i].contas_pagar[j].plano_financeiro_id == 
                  plano_financeiro_conta_pagar[y].plano_financeiro_id
                ) {
                  this.mapa_financeiro_dados[i].contas_pagar[j].plano_financeiro_nome = plano_financeiro_conta_pagar[y].nome;
                  break;
                }
              }

              delete this.mapa_financeiro_dados[i].contas_pagar[j].plano_financeiro_id;
              delete this.mapa_financeiro_dados[i].contas_pagar[j].vencimento;
            }

            this.mapa_financeiro_dados[i].soma_previsoes_pagar = (
              this.mapa_financeiro_dados[i].previsoes_pagar.reduce(
                (total_soma_previsoes_pagar, elem) => 
                total_soma_previsoes_pagar + 
                Biblioteca.valor(elem.total), 
                0 
              )
            );

            for (let j = 0; j < this.mapa_financeiro_dados[i].previsoes_pagar.length; j++) {
              for (let y = 0; y < plano_financeiro_previsao_pagar.length; y++) {
                if (
                  this.mapa_financeiro_dados[i].previsoes_pagar[j].plano_financeiro_id == 
                  plano_financeiro_previsao_pagar[y].plano_financeiro_id
                ) {
                  this.mapa_financeiro_dados[i].previsoes_pagar[j].plano_financeiro_nome = plano_financeiro_previsao_pagar[y].nome;
                  break;
                }
              }

              delete this.mapa_financeiro_dados[i].previsoes_pagar[j].plano_financeiro_id;
              delete this.mapa_financeiro_dados[i].previsoes_pagar[j].vencimento;
            }

            this.mapa_financeiro_dados[i].total_pagar = (
              this.mapa_financeiro_dados[i].soma_previsoes_pagar +
              this.mapa_financeiro_dados[i].soma_contas_pagar
            );

            this.mapa_financeiro_dados[i].total_realizado = (
              this.mapa_financeiro_dados[i].soma_contas_receber - 
              this.mapa_financeiro_dados[i].soma_contas_pagar
            );

            this.mapa_financeiro_dados[i].total_previsto = (
              Biblioteca.valor(this.mapa_financeiro_dados[i].previsoes_venda) - 
              this.mapa_financeiro_dados[i].soma_previsoes_pagar
            );

            this.mapa_financeiro_dados[i].total_realizado_previsto = (
              this.mapa_financeiro_dados[i].total_realizado +
              this.mapa_financeiro_dados[i].total_previsto
            );

            this.mapa_financeiro_dados[i].saldo_final = (
              this.mapa_financeiro_dados[i].total_realizado_previsto +
              this.mapa_financeiro_dados[i].saldo_inicial
            );

            this.mapa_financeiro_dados[i].total_a_receber = (
              this.mapa_financeiro_dados[i].soma_contas_receber + 
              Biblioteca.valor(this.mapa_financeiro_dados[i].previsoes_venda)
            );

            saldo_inicial = this.mapa_financeiro_dados[i].saldo_final;

            dados_mapa_financeiro.total_contas_receber += this.mapa_financeiro_dados[i].soma_contas_receber;
            dados_mapa_financeiro.total_previsoes_venda += Biblioteca.valor(this.mapa_financeiro_dados[i].previsoes_venda);
            dados_mapa_financeiro.total_receber += this.mapa_financeiro_dados[i].total_a_receber;
            dados_mapa_financeiro.total_contas_pagar += this.mapa_financeiro_dados[i].soma_contas_pagar;
            dados_mapa_financeiro.total_previsoes_pagar += this.mapa_financeiro_dados[i].soma_previsoes_pagar;
          }

          dados_mapa_financeiro.total_saldos = Biblioteca.valor(informacoes_estaticas.saldo_inicial);

          dados_mapa_financeiro.total_realizado = this.mapa_financeiro_dados.reduce(
            function(prevVal, elem) {
              return prevVal + elem.total_realizado;
            }, 
            0
          );

          dados_mapa_financeiro.total_previsto = this.mapa_financeiro_dados.reduce(
            function(prevVal, elem) {
              return prevVal + elem.total_previsto;
            },
            0
          );

          dados_mapa_financeiro.total_realizado_previsto = this.mapa_financeiro_dados.reduce(
            function(prevVal, elem) {
              return prevVal + elem.total_realizado_previsto;
            },
            0
          );

          let tamanhoArray = this.mapa_financeiro_dados.length - 1;
          dados_mapa_financeiro.saldo_final = this.mapa_financeiro_dados[tamanhoArray].saldo_final;
          this.dados_mapa_financeiro = dados_mapa_financeiro;

          //COMEÇA ANALÍTICO MODELO 2
          this.analitico_modelo_dois = {
            'contas_receber': [],
            'contas_pagar': []
          };

          /* ------------ INFORMAÇÕES ANALITICAS MODELO 2 ------------ */
          let informacoes_analitico_modelo_2 = retorno.dados.informacoes_analitico_modelo_2;

          let plano_financeiro_modelo2_receber = informacoes_analitico_modelo_2.plano_financeiro_receber;
          let plano_financeiro_modelo2_pagar = informacoes_analitico_modelo_2.plano_financeiro_pagar;

          //Busca Plano Financeiro Pai de Contas a Receber
          let plano_financeiro_receber_pais_total = plano_financeiro_modelo2_receber.map(
            function(elem) {
              return {
                nome_pai: elem.nome_pai,
                id_pai: elem.plano_financeiro_pai_id
              }
            }
          );

          //Busca Plano Financeiro Pagar Pai de Contas a Pagar
          let plano_financeiro_pagar_pais_total = plano_financeiro_modelo2_pagar.map(
            function(elem) {
              return {
                nome_pai: elem.nome_pai,
                id_pai: elem.plano_financeiro_pai_id
              }
            }
          );

          //Elimina repetidos de Plano Financeiro Pai - contas a receber
          let plano_financeiro_receber_pais = plano_financeiro_receber_pais_total.filter(
            (elem, index, self) =>
            index === self.findIndex(
              (indice) => (
                indice.nome_pai === elem.nome_pai
              )
            )
          );

          //Elimina repetidos de Plano Financeiro Pai - contas a pagar
          let plano_financeiro_pagar_pais = plano_financeiro_pagar_pais_total.filter(
            (elem, index, self) =>
            index === self.findIndex(
              (indice) => (
                indice.nome_pai === elem.nome_pai
              )
            )
          );

          for (let i in plano_financeiro_receber_pais) {
            let array_por_plano_financeiro = plano_financeiro_modelo2_receber.filter(
              function(valor) {
                return valor.nome_pai == plano_financeiro_receber_pais[i].nome_pai;
              }
            );

            this.analitico_modelo_dois.contas_receber.push(
              {
                contas_receber: [],
                plano_financeiro_pai: null,
                plano_financeiro_pai_id: null,
                soma_valor_contas_receber: null,
                soma_previsao_contas_receber: null,
                soma_total_contas_receber: null,
                soma_av_contas_receber: null
              }
            );

            this.analitico_modelo_dois.contas_receber[i].contas_receber = Object.assign([], array_por_plano_financeiro);
            this.analitico_modelo_dois.contas_receber[i].plano_financeiro_pai = plano_financeiro_receber_pais[i].nome_pai;
            this.analitico_modelo_dois.contas_receber[i].plano_financeiro_pai_id = plano_financeiro_receber_pais[i].id_pai;

            this.analitico_modelo_dois.contas_receber[i].soma_valor_contas_receber = (
              this.analitico_modelo_dois.contas_receber[i].contas_receber.reduce(
                (valor_soma_contas_receber, elem) => 
                valor_soma_contas_receber + 
                Biblioteca.valor(elem.total),
                0
              )
            );

            this.analitico_modelo_dois.contas_receber[i].soma_previsao_contas_receber = (
              this.analitico_modelo_dois.contas_receber[i].contas_receber.reduce(
                (previsao_soma_contas_receber, elem) =>
                previsao_soma_contas_receber + 
                Biblioteca.valor(elem.total_previsao),
                0
              )
            );

            this.analitico_modelo_dois.contas_receber[i].soma_total_contas_receber = (
              this.analitico_modelo_dois.contas_receber[i].soma_valor_contas_receber +
              this.analitico_modelo_dois.contas_receber[i].soma_previsao_contas_receber
            );

            this.analitico_modelo_dois.contas_receber[i].soma_av_contas_receber = (
              this.analitico_modelo_dois.contas_receber[i].contas_receber.reduce(
                (av_soma_contas_receber, elem) =>
                av_soma_contas_receber +
                Biblioteca.valor(elem.total),
                0
              )
            );
          }

          for (let i in plano_financeiro_pagar_pais) {
            let array_por_plano_financeiro =  plano_financeiro_modelo2_pagar.filter(
              function(valor) {
                return valor.nome_pai == plano_financeiro_pagar_pais[i].nome_pai;
              }
            );

            this.analitico_modelo_dois.contas_pagar.push({
              contas_pagar: [],
              plano_financeiro_pai: null,
              plano_financeiro_pai_id: null,
              soma_valor_contas_pagar: null,
              soma_previsao_contas_pagar: null,
              soma_total_contas_pagar: null,
              soma_av_contas_pagar: null
            });

            this.analitico_modelo_dois.contas_pagar[i].contas_pagar = Object.assign([], array_por_plano_financeiro);
            this.analitico_modelo_dois.contas_pagar[i].plano_financeiro_pai = plano_financeiro_pagar_pais[i].nome_pai;
            this.analitico_modelo_dois.contas_pagar[i].plano_financeiro_pai_id = plano_financeiro_pagar_pais[i].id_pai;

            this.analitico_modelo_dois.contas_pagar[i].soma_valor_contas_pagar = (
              this.analitico_modelo_dois.contas_pagar[i].contas_pagar.reduce(
                (valor_soma_contas_pagar, elem) =>
                valor_soma_contas_pagar +
                Biblioteca.valor(elem.total),
                0
              )
            );

            this.analitico_modelo_dois.contas_pagar[i].soma_previsao_contas_pagar = (
              this.analitico_modelo_dois.contas_pagar[i].contas_pagar.reduce(
                (previsao_soma_contas_pagar, elem) =>
                previsao_soma_contas_pagar +
                Biblioteca.valor(elem.total_previsao),
                0
              )
            );

            this.analitico_modelo_dois.contas_pagar[i].soma_total_contas_pagar = (
              this.analitico_modelo_dois.contas_pagar[i].soma_valor_contas_pagar +
              this.analitico_modelo_dois.contas_pagar[i].soma_previsao_contas_pagar
            );

            this.analitico_modelo_dois.contas_pagar[i].soma_av_contas_pagar = (
              this.analitico_modelo_dois.contas_pagar[i].contas_pagar.reduce(
                (av_soma_contas_pagar, elem) =>
                av_soma_contas_pagar +
                Biblioteca.valor(elem.total),
                0
              )
            );
          }

          this.processando = false;
        }
        catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      }
    },
    
    computed: {
      buscarDiferencaEntreDias: function() {
        let primeiro_dia = moment(this.conf_local.data_inicial);
        let ultimo_dia = moment(this.conf_local.data_final);

        return ultimo_dia.diff(primeiro_dia, 'days') + 1;
      },

      existeCardsSaldos: function() {
        if(this.conf_local.visibilidade.conta_caixa || this.conf_local.visibilidade.contas_bancarias) {
          return true;
        } else {
          return false;
        }
      },

      existeCardsRealizadoInicioRelatorio: function() {
        if
          (
            this.conf_local.visibilidade.receber_realizado || 
            this.conf_local.visibilidade.cheques_pagar || 
            this.conf_local.visibilidade.pagar_duplicata_cheque_abertos || 
            this.conf_local.visibilidade.dbc_pagar_vencidos
          ) 
        {
          return true;
        } else {
          return false;
        }
      },

      existeCardsPrevisoesInicioRelatorio: function() {
        if(this.conf_local.visibilidade.pagar_previsoes || this.conf_local.visibilidade.receber_previsoes) {
          return true;
        } else {
          return false;
        }
      },

      existeCardsTitulosReceber: function() {
        if
          ( 
            this.conf_local.visibilidade.tres_dias || 
            this.conf_local.visibilidade.quinze_dias || 
            this.conf_local.visibilidade.trinta_dias ||
            this.conf_local.visibilidade.sessenta_dias || 
            this.conf_local.visibilidade.noventa_dias
          ) 
        {
          return true;
        } else {
          return false;
        }
      },

      existePrevisoesVencidas: function() {
        if(this.conf_local.visibilidade.previsoes_pagar_vencidas) {
          return true;
        } else {
          return false;
        }
      },
    },

    async mounted() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
      
      await this.buscarConfiguracoesLocais();
      await this.buscarMapaFinanceiro()
    },
  
  }
</script>

<style scoped>
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
  }
  .table-mapa-financeiro {
    padding-left: 0px;
    padding-right: 0px;
}
  #principal {
    padding-bottom: 20px;
  }

  .configuracoes-botao {
    text-decoration: underline;
    cursor: pointer;
  }

  .configuracoes-botao:hover {
    text-decoration: none
  }

  .text-center {
    text-align: center;
  }

  .configuracoes-mapa-financeiro {
    text-align: left;
  }

  .tablink {
    cursor: pointer
  }

  .card-dashboard {
    border-radius: 10px;
    float: left;
    width: calc((100% / 4) - 15px);
    margin: 0 auto;
    background-color: #e6e6e6;
    padding: 20px;
    margin-right: 15px;
    margin-bottom: 15px;
    position: relative;
    display: table;
    text-align: center;
  }

  .card-dashboard-escondido {
    display: none !important;
  }

  .card-clicavel-titulo {
    text-decoration: underline
  }

  .card-dashboard.card-dashboard-ativo .w3-display-topright i, .card-dashboard.card-dashboard-ativo .card-dashboard-titulo, .card-dashboard.card-dashboard-ativo .card-dashboard-dado {
    color: white !important
  }

  .card-dashboard.card-dashboard-ativo .card-dashboard-inner .icone-card {
    color: white;
    border: 2px solid white;
  }

  .card-dashboard .card-dashboard-inner {
    display: table-cell;
    position: relative;
    height: 205px;
    padding-top: 10px;
  }

  .card-dashboard .card-dashboard-inner .icone-card {
    color: #9c1d1c;
    display: inline-block;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    border: 2px solid #9c1d1c;
    margin-bottom: 15px;
    line-height: 80px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 3em;
  }

  .card-dashboard .card-dashboard-inner .w3-right-align {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  @media(max-width: 1700px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 1366px) {

    .container-cards {
      padding: 0 10% !important;
    }
  }

  @media(max-width: 1085px) {
    .card-dashboard {
      width: calc((100%/3) - 15px)
    }
  }

  @media(max-width: 845px) {
    .card-dashboard {
      width: calc((100%/2) - 15px)
    }
  }

  @media(max-width: 645px) {
    .card-dashboard {
      width: 100%;
      margin-right: 0 !important;
      text-align: center;
    }

    .container-cards {
      padding: 0 !important;
    }

    .card-dashboard .w3-right-align {
      text-align: center !important;
    }
    .mapa-financeiro > div.w3-container{
      padding:0 !important;
    }
  }

  .card-dashboard-titulo {
    font-size: 1.2em;
    color: #666;
    width: 100%;
    display: block;
    text-align: center;
  }

  .card-dashboard-dado {
    font-size: 2em;
    font-weight: bold;
    color: #9c1d1c;
  }

  .card-dashboard-dado.reduzido {
    font-size: 1.4em !important;
  }

  .texto-reduzido, .card-dashboard-dado {
    font-size: 1.5em !important;
  }

  h2{
    border-bottom: 1px solid #9c1d1c;
  }


  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  @media screen and (max-width: 767px){
    h2{
      font-size: 24px;
      margin-bottom:15px;
    }
  }

  @media screen and (min-width: 1199px){
    .flexbox-pai .item{
      min-height:135px;
    }

    .flexbox-pai2 .item{
      min-height:260px;
    }
  }

  .item{
    border:1px solid #c6c6c6;
    border-radius: 10px;
    overflow:hidden;
  }
  .bloco{
    padding: 5px 16px
  }

  .label-info {
    line-height: 35px;
    border-bottom: 1px solid black
  }

  .line-label {
    line-height: 35px;
    text-align: right;
    border-bottom: 1px solid black
  }

  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/MapaFinanceiro.vue